/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  DepositRequest,
  WithdrawRequest
} from './schema'



export const utxCommoditiesListSizes = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/commodities/brands-and-sizes`,options
    );
  }


export const getUtxCommoditiesListSizesQueryKey = () => [`/commodities/brands-and-sizes`];

    
export type UtxCommoditiesListSizesQueryResult = NonNullable<Awaited<ReturnType<typeof utxCommoditiesListSizes>>>
export type UtxCommoditiesListSizesQueryError = AxiosError<unknown>

export const useUtxCommoditiesListSizes = <TData = Awaited<ReturnType<typeof utxCommoditiesListSizes>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCommoditiesListSizes>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCommoditiesListSizesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCommoditiesListSizes>>> = ({ signal }) => utxCommoditiesListSizes({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCommoditiesListSizes>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCommoditiesDeposit = (
    depositRequest: DepositRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/commodities/deposit`,
      depositRequest,options
    );
  }



    export type UtxCommoditiesDepositMutationResult = NonNullable<Awaited<ReturnType<typeof utxCommoditiesDeposit>>>
    export type UtxCommoditiesDepositMutationBody = DepositRequest
    export type UtxCommoditiesDepositMutationError = AxiosError<unknown>

    export const useUtxCommoditiesDeposit = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCommoditiesDeposit>>, TError,{data: DepositRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCommoditiesDeposit>>, {data: DepositRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCommoditiesDeposit(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCommoditiesDeposit>>, TError, {data: DepositRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCommoditiesWithdraw = (
    withdrawRequest: WithdrawRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/commodities/withdraw`,
      withdrawRequest,options
    );
  }



    export type UtxCommoditiesWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof utxCommoditiesWithdraw>>>
    export type UtxCommoditiesWithdrawMutationBody = WithdrawRequest
    export type UtxCommoditiesWithdrawMutationError = AxiosError<unknown>

    export const useUtxCommoditiesWithdraw = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCommoditiesWithdraw>>, TError,{data: WithdrawRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCommoditiesWithdraw>>, {data: WithdrawRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCommoditiesWithdraw(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCommoditiesWithdraw>>, TError, {data: WithdrawRequest}, TContext>(mutationFn, mutationOptions)
    }
    